import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/components/Home'
import Products from '@/components/Products'
import InsideProduct from '@/components/InsideProduct'
import Contacts from '@/components/Contacts'
import error404 from '@/components/Error404'

Vue.use(Router)

let routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/products',
        name: 'Products',
        component: Products
    },
    {
        path: '/product/:slug/:id',
        name: 'InsideProduct',
        component: InsideProduct
    },
    {
        path: '/contacts',
        name: 'Contacts',
        component: Contacts
    },
    {
        path: '*',
        component: error404
    }
]

const vueRouter = new Router({
    mode: 'history',
    routes
})

vueRouter.beforeEach(function (to, from, next) {
    window.scrollTo(0, 0)
    next()
})

export default vueRouter



// WEBPACK FOOTER //
// ./src/router/index.js